import { render, staticRenderFns } from "./ListVendor.vue?vue&type=template&id=53c26d3b&scoped=true"
import script from "./ListVendor.vue?vue&type=script&lang=js"
export * from "./ListVendor.vue?vue&type=script&lang=js"
import style0 from "./ListVendor.vue?vue&type=style&index=0&id=53c26d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c26d3b",
  null
  
)

export default component.exports